var allItems = [];
var selectedItems = [];
// var baseUrl = ""

const allItemVanillaTemplate = (item) => {
  const saleImage = item.metafields.find(m => m.key === "sale_image")?.value;
  const imageUrl = saleImage || item.featuredImage.url;
  const altText = item.featuredImage.altText || item.title;

  return `
  <div class="product-card-row">
    <div class="box-sale-product-card ${item.quantity > 0 ? "box-sale-product-card-active" : ""}">
      <div class="box-sale-product-image-div">
           <img class="box-sale-product-bg-image product-popup-trigger"
     src="${imageUrl}" alt="${altText}" style="cursor: pointer;"
     data-title="${item.title.replace(/"/g, "&quot;")}"
     data-image="${imageUrl}"
     data-description='${item.description?.replace(/'/g, "&apos;") || ""}'
     data-variants='${JSON.stringify(item.variants).replace(/'/g, "&apos;")}'
     data-units-sold="${item.unitsSold}"
         >
      </div>
      <div class="box-sale-product-details">
          <div class="box-sale-product-title">
              ${item.title}
          </div>
          <div class="product-card-fixed-bottom-container">
            <div class="box-sale-product-price">
               ${Shopify.country == 'GB' ? '£' : '$' }&nbsp;${item.variants[0].priceV2.amount}
            </div>
            <div class="box-sale-product-quantity">
              <button class="box-sale-product-quantity-button box-sale-product-minus ${item.quantity < 1 ? "visibility-hidden" : ""}" data-variant-id="${item.variants[0].id}" >-</button>
                <input class="${item.quantity < 1 ? "visibility-hidden" : ""}" type="text"  value="${item.quantity}" readonly>
              <button class="box-sale-product-quantity-button box-sale-product-plus ${item.quantity < 1 ? "custom-add-button" : ""}" data-variant-id="${item.variants[0].id}">${item.quantity > 0 ? "+" : `Add to Box`}</button>
            </div>
          </div>
      </div>
    </div>
  </div>
`};

function showProductPopup(item) {
  const formattedUnitsSold = Number(item.unitsSold || 0).toLocaleString();

  // Create a temporary container to parse the description HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = item.description;

  const allowedSections = [
    "Product Description",
    "Ingredients",
    "Benefits",
    "How to Use",
    "Precautions",
  ];
  const selectedContent = [];

  const allNodes = Array.from(tempDiv.childNodes);
  let collect = false;

  allNodes.forEach((node) => {
    if (node.tagName === "H2") {
      const headerText = node.textContent.trim().replace(/[\:\s]+$/, "");
      if (allowedSections.includes(headerText)) {
        collect = true;
        selectedContent.push(`<h2><strong>${headerText}</strong></h2>`);
        return;
      } else {
        collect = false;
      }
    }

    if (collect) {
      selectedContent.push(node.outerHTML || node.textContent);
    }
  });

  const descriptionContent = selectedContent.length
    ? selectedContent.join("")
    : "<p>No description available.</p>";

  const popup = document.createElement("div");
  popup.id = "product-detail-popup";
  popup.innerHTML = `
    <div class="popup-overlay"></div>
    <div class="popup-container">
      <div class="popup-scrollable">

          <div class="popup-header">
    <h1></h1>
    <button class="popup-close-btn">&times;</button>
  </div>

      <div class="popup-body">
        <div class="popup-left">
          <img src="${item.featuredImage.url}" alt="${item.title}" class="popup-image">
        </div>
        <div class="popup-right">
          <h2>${item.title}</h2>
    <span class="popup-units">${formattedUnitsSold} Units Sold</span>

          <div class="popup-description">
            <p>${item.description}</p>
          </div>
        </div>
      </div>
       </div>
    </div>
  `;
  document.body.appendChild(popup);
  document.body.style.overflow = "hidden";

    const style = document.createElement("style");
  style.id = "popup-style";
  style.textContent = `
    #product-detail-popup {
      position: fixed; top: 0; left: 0;
      width: 100%; height: 100%;
      display: flex; align-items: center; justify-content: center;
      z-index: 9999;
      font-family:Montserrat;
    }
    .popup-overlay {
      position: absolute; width: 100%; height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }
  .popup-container {
  position: relative;
  background: #fff;
  border-radius: 12px;
  max-width: 900px;
  width: 90%;
  display: flex;
  flex-direction: column;
  z-index: 10000;
  padding: 15px 20px;
  font-family: Montserrat;
  max-height: 75vh; 
  overflow: hidden; 
 }

.popup-scrollable {
  overflow-y: auto;
  max-height: 100%;
 }
    .popup-header h1 {
  margin: 0;
   font-size: 18px;
    font-weight: 400;
    color: #000000;
 }

.popup-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
    .popup-body {
      display: flex; gap: 20px; flex-wrap: wrap;margin-top:10px;
    }
    .popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
    .popup-left, .popup-right {
      flex: 1;
       min-width: 300px;
    }
    .popup-left {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    justify-content: start;
}
    .popup-image {
      width: 100%; border-radius: 8px; object-fit: contain;
    }
   
    .popup-units {
    display: inline-block;
    margin: 10px 0;
    padding: 7px 21px;
    background: #CCFFBA;
    color: #235B0F;
    font-size: 14px;
    border-radius: 8px;
    font-weight: 500;
}
    .popup-reviews {
        margin: 10px 0px;
    position: relative;
    font-size: 14px;
    font-weight: 500;
    color: #212121;
    margin-top:0px
    }
    .popup-right h2{
    font-size:28px;
    font-weight:600;
    margin:0px
    }
     .popup-right popup-title {
     font-size:17.02px;
     font-weight:500
     }
     .popup-description-heading{
     font-size:17.02px;
     font-weight:500;
     }
    .stars {
    color: #FF985E;
    letter-spacing: 5px;
    font-size: 18px;
}
   
    .popup-description {
    font-size: 12px;
    color: #212121;
    margin-bottom: 15px;
    font-weight: 500;
}
    .popup-description  ul > li > span {
  font-weight: 500 !important;
}

   .popup-description  p>span {
  font-weight: 500 !important;
}
    
  
   
.popup-description strong{
font-size:17px;
fontt-weight:500;
}
@media (max-width: 768px) {
  .popup-body {
    flex-direction: column;
    align-items: center;
  }
  .popup-left, .popup-right {
    min-width: 100%;
  }
  .popup-right h2{
  font-size:20px
  }
  .popup-header h1 {
    font-size: 22px;
  }
  .popup-description-heading {
    font-size: 14px;
  }
  .popup-reviews{
  font-size:10px;
  margin-top:0px;
  }
  .popup-units {
    font-size: 12px;
  }
  .popup-description {
    font-size: 14px;
  }
  
}
  `;
  document.head.appendChild(style);
  const closePopup = () => {
    popup.remove();
    document.body.style.overflow = "";
  };
  // Close popup when clicked
  popup.querySelector(".popup-close-btn").onclick = closePopup;
  popup.querySelector(".popup-overlay").onclick = closePopup;
}

const selectedItemVanillaTemplate = (item, index) => item.quantity > 0 ? `
  <div class="selected-box-item" style="">
    <div class="selected-product ${!item ? "active-empty" : ""} ${item ? "selected-product-background" : ""}">
        ${
          item ? `<img class="box-sale-product-bg-image" src="${item.featuredImage.url}" alt="">` : ``
        }
        ${
          !item
            ? `
            <div>
                ADD
            </div>
            <div>
                Item ${index + 1}
            </div>`
            : ``
        }
        <div>
            <span class="custom-offer-button custom-offer-remove close-x">${item.quantity}</span>
        </div>
    </div>
    ${item ? `<div class="selected-product-title">${item.title}</div>` : ``}
  </div>
  ` : ``;

const bottomActionsVanillaTemplate = (items, totalQuantity, selectedItemVanillaTemplate) => `
  <div class="bottom-actions-nudge ${totalQuantity >= 5 ? "congrats-banner" : ""}" style="${totalQuantity >= 5 ? "background: #177D5D; color: white;" : ""}">
    ${totalQuantity < 5 ? `Add ${5 - totalQuantity} ${totalQuantity >= 1 ? "more" : ""} product${totalQuantity < 2 ? "s" : ""} to unlock this offer` : "Congrats!! Free gift added to cart.  "}
  </div>
  <div class="bottom-actions-container">
    <div class="selected-items selected-items-bottom" id="selected-items-bottom"></div>
    <button id="bottom-actions-container-checkout" ${totalQuantity < 5 ? "disabled" : ""}> ADD TO CART </button>
  </div>
`;

function renderVanilla(allItems, selectedItems) {
  //$("#selected-items").html(selectedItemSlots.map(selectedItemVanillaTemplate).join(""));
  let totalQuantity = selectedItems.reduce(
    (accumulator, currentValue) => accumulator + currentValue.quantity,
    0,
  );
  document.getElementById("all-items").innerHTML =
  allItems.map(allItemVanillaTemplate).join("");

document.getElementById("bottom-actions").innerHTML =
  bottomActionsVanillaTemplate(selectedItems, totalQuantity);

const selectedBottom = document.getElementById("selected-items-bottom");
if (selectedBottom) {
  selectedBottom.innerHTML =
    selectedItems.map(selectedItemVanillaTemplate).join("");
}
}

function delegateEventHandler(event) {
  console.log(event);
  let totalQuantity;
  if (
    (event.target.tagName === "BUTTON" &&
    event.target.classList.contains("box-sale-product-plus")) ||
    (event.target.tagName === "svg" && event.target.parent.classList.contains("box-sale-product-plus"))
  ) {
    totalQuantity = selectedItems.reduce(
      (accumulator, currentValue) => accumulator + currentValue.quantity,
      0,
    );
    if (totalQuantity >= 5) {
      return;
    }
    let addedItem = allItems.findIndex(
      (it) => it.variants[0].id === event.target.dataset.variantId
    );
    let itemInCart = selectedItems.findIndex(
      (it) => it.variants[0].id === event.target.dataset.variantId
    );
    if(itemInCart !== -1) {
      selectedItems[itemInCart].quantity = parseInt(event.target.parentElement.parentElement.querySelector('input').value) + 1;
      allItems[addedItem].quantity = selectedItems[itemInCart].quantity;
    }
    else{
      allItems[addedItem].quantity = 1;
      selectedItems.push(allItems[addedItem]);
    }
    localStorage.setItem("selectedItemsv4.5", JSON.stringify(selectedItems));
    renderVanilla(allItems, selectedItems);
    totalQuantity = selectedItems.reduce(
      (accumulator, currentValue) => accumulator + currentValue.quantity,
      0,
    );
    if(totalQuantity === 5){
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
      });
    }
  } else if (
    (event.target.tagName === "BUTTON" &&
    event.target.classList.contains("box-sale-product-minus")) ||
    (event.target.tagName === "svg" && event.target.parent.classList.contains("box-sale-product-minus"))
  ) {
    if(parseInt(event.target.parentElement.parentElement.querySelector('input').value) === 0){
      return;
    }
    let removedItem = allItems.findIndex(
      (it) => it.variants[0].id === event.target.dataset.variantId
    );
    let itemInCart = selectedItems.findIndex(
      (it) => it.variants[0].id === event.target.dataset.variantId
    );
    if(itemInCart !== -1) {
      selectedItems[itemInCart].quantity = parseInt(event.target.parentElement.parentElement.querySelector('input').value) - 1;
      allItems[removedItem].quantity = selectedItems[itemInCart].quantity;
    }
    else{
      return
    }
    localStorage.setItem("selectedItemsv4.5", JSON.stringify(selectedItems));
    renderVanilla(allItems, selectedItems);
  } else if (
    event.target.tagName === "BUTTON" &&
    event.target.id === "bottom-actions-container-checkout"
  ) {
    redirectToCheckout();
  }
}

function withoutEdgesAndNodes(data) {
  let result = Array.isArray(data) ? [] : {};

  if (typeof data !== "object") return data;

  for (const key in data) {
    if (typeof key === "string" && key === "edges") {
      result = withoutEdgesAndNodes(data.edges.map((edge) => edge.node));
    } else {
      result = Object.assign(result, {
        [key]: withoutEdgesAndNodes(data[key]),
      });
    }
  }

  return result;
}


// function redirectToCheckout() {
//   let settings = {
//     url: baseUrl + "/cart/add.js",
//     method: "POST",
//     timeout: 0,
//     headers: {
//       "Content-Type": "application/json",
//     },
//     data: JSON.stringify({
//       'items': selectedItems.map(it => ({quantity: it.quantity, id: it.variants[0].id.split('/').pop()}))
//      }),
//   };

//   $.ajax(settings).done(function (response) {
//   })
// }

// function redirectToCheckout() {
//   const data = {
//     items: selectedItems.map(it => ({
//       quantity: it.quantity,
//       id: it.variants[0].id.split('/').pop()
//     }))
//   };

//   fetch("/cart/add.js", {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(data)
//   })
//   .then(r => r.json())
//   .then(res => console.log('Added to cart:', res))
//   .catch(err => console.error('Error:', err));
// }



function redirectToCheckout() {

  const FREE_GIFT_ID = "53070925693294"; // numeric variant ID

  // 1️⃣ Build cart items (NO zero qty, NO invalid ids)
  const cartItems = selectedItems
    .filter(it => it.quantity > 0 && it.variants?.[0]?.id)
    .map(it => ({
      quantity: it.quantity,
      id: it.variants[0].id.split('/').pop()
    }));

  const totalQty = cartItems.reduce((sum, i) => sum + i.quantity, 0);

  // 2️⃣ Add free gift ONLY when unlocked
  if (totalQty >= 5) {
    cartItems.push({
      id: FREE_GIFT_ID,
      quantity: 1
    });
  }

 // 3️⃣ CLEAR CART FIRST
  fetch("/cart/clear.js", {
    method: "POST"
  })
  .then(() => {
    // 4️⃣ Add items to cart
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: cartItems })
    });
  })
  .then(res => res.json())
  .then(res => {
    if (res.status === 422) {
      console.error("Cart error", res);
    } else {
      // window.location.href = "/cart";
    }
  });
}



// function loadInitData() {
//   const countryCode = Shopify.country || 'US'; // Use 'US' as a fallback default value
//   const dynamicTag = window.dynamicTag || 'new-year-2026-us'; // fallback just in case

//   let settings = {
//     url: baseUrl + "/api/2023-01/graphql.json",
//     method: "POST",
//     timeout: 0,
//     headers: {
//       "X-Shopify-Storefront-Access-Token": "a6beb826c2b8c0c31b5301e04882fd81",
//       "Content-Type": "application/json",
//     },
//     data: JSON.stringify({
//       query: `
//         query allProducts($country: CountryCode!,$productTag: String!) @inContext(country: $country) {
//           products(first: 100, query: $productTag) {
//             edges {
//               node {
//                 id
//                 title
//                 featuredImage {
//                   url
//                   altText
//                 }
//                 metafields(identifiers: [

//                     { namespace: "custom", key: "buy_100_sort_order" },

//                     { namespace: "custom", key: "sale_image" },
//                     { namespace: "custom", key: "units_sold" }

//                   ]) {

//                     namespace

//                     key

//                     value

//                     type

//                   }
//                 variants(first: 1) {
//                   edges {
//                     node {
//                       id
//                       priceV2 {
//                         amount
//                         currencyCode
//                       }
//                     }
//                   }
//                 }
//                   descriptionHtml
//               }
//             }
//           }
//         }
//       `,
//       variables: {
//         country: countryCode,
//         productTag: `tag:'${dynamicTag}' AND NOT tag:'${dynamicTag}-hidden'`
//       },
//     }),
//   };

//   $.ajax(settings).done(function (response) {
//     console.log('response', response);
//     let data = withoutEdgesAndNodes(response.data);
//     data.products = data.products.sort((a, b) => {

//     const aSortValue = parseInt((a.metafields.find(m => m.key === "buy_100_sort_order") || {}).value || 0);

//     const bSortValue = parseInt((b.metafields.find(m => m.key === "buy_100_sort_order") || {}).value || 0);

//     return aSortValue - bSortValue;

//   });
//     selectedItems = localStorage.getItem("selectedItemsv5.5")
//       ? JSON.parse(localStorage.getItem("selectedItemsv5.5"))
//       : [];
//     allItems = selectedItems.length
//       ? data.products.map((it) => {
//         let selectedItemLocal = selectedItems.find(itl => itl.id === it.id);
//         it["quantity"] = selectedItemLocal ? selectedItemLocal.quantity : 0;
//         it["description"] = it.descriptionHtml || "No description available.";
//           it["unitsSold"] =
//             (it.metafields.find((m) => m.key === "units_sold") || {}).value ||
//             "0";
//         return it;
//         })
//       : data.products.map(it => {
//         it.quantity = 0;
//         it["description"] = it.descriptionHtml || "No description available.";
//           it["unitsSold"] =
//             (it.metafields.find((m) => m.key === "units_sold") || {}).value ||
//             "0";
//         return it;
//     });
//     renderVanilla(allItems, selectedItems);

//   });
// }

function loadInitData() {
  const baseUrl = "https://marshealthboosters.com/";
  const countryCode = Shopify.country || "US"; // fallback
  const dynamicTag = window.dynamicTag || "easter-2026-sale"; // fallback
  fetch(baseUrl + "/api/2023-01/graphql.json", {
    method: "POST",
    headers: {
      "X-Shopify-Storefront-Access-Token": "00f3d282ef94a5c8913c3b0466fbc0be",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query: `
        query allProducts($country: CountryCode!,$productTag: String!)
        @inContext(country: $country) {
          products(first: 100, query: $productTag) {
            edges {
              node {
                id
                title
                featuredImage {
                  url
                  altText
                }
                metafields(identifiers: [
                  { namespace: "custom", key: "buy_100_sort_order" },
                  { namespace: "custom", key: "sale_image" },
                  { namespace: "custom", key: "units_sold" }
                ]) {
                  namespace
                  key
                  value
                  type
                }
                variants(first: 1) {
                  edges {
                    node {
                      id
                      priceV2 {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
                descriptionHtml
              }
            }
          }
        }
      `,
      variables: {
        country: countryCode,
        productTag: `tag:'${dynamicTag}'`
      }
    })
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      return res.json();
    })
    .then((response) => {
      console.log("response", response);

      let data = withoutEdgesAndNodes(response.data);

      data.products = data.products.sort((a, b) => {
        const aSortValue = parseInt(
          (a.metafields.find(m => m.key === "buy_100_sort_order") || {}).value || 0
        );
        const bSortValue = parseInt(
          (b.metafields.find(m => m.key === "buy_100_sort_order") || {}).value || 0
        );
        return aSortValue - bSortValue;
      });

      selectedItems = localStorage.getItem("selectedItemsv4.5")
        ? JSON.parse(localStorage.getItem("selectedItemsv4.5"))
        : [];

      allItems = selectedItems.length
        ? data.products.map((it) => {
            let selectedItemLocal = selectedItems.find((itl) => itl.id === it.id);
            it["quantity"] = selectedItemLocal ? selectedItemLocal.quantity : 0;
            it["description"] = it.descriptionHtml || "No description available.";
            it["unitsSold"] =
              (it.metafields.find((m) => m.key === "units_sold") || {}).value || "0";
            return it;
          })
        : data.products.map((it) => {
            it.quantity = 0;
            it["description"] = it.descriptionHtml || "No description available.";
            it["unitsSold"] =
              (it.metafields.find((m) => m.key === "units_sold") || {}).value || "0";
            return it;
          });

      renderVanilla(allItems, selectedItems);
    })
    .catch((error) => {
      console.error("GraphQL fetch error:", error);
    });
}



window.addEventListener("load", (event) => {

  document.addEventListener('click',function(event){
    try{
      delegateEventHandler(event);
    }
    catch(e) {
      console.log(e);
    }
 });
window.addEventListener("load", () => {
  const listEl = document.querySelector(".selected-products-list");
  const headerEl = document.querySelector("#shopify-section-header");
  
  if (listEl && headerEl) {
    listEl.style.top = headerEl.clientHeight + "px";
  }
});  loadInitData();
});

 document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("product-popup-trigger")) {
      const el = e.target;

      try {
        const item = {
          title: el.dataset.title,
          featuredImage: { url: el.dataset.image },
          description: el.dataset.description?.replace(/&apos;/g, "'") || "",
          variants: JSON.parse(el.dataset.variants.replace(/&apos;/g, "'")),
          unitsSold: el.dataset.unitsSold || "0",
        };
        showProductPopup(item);
      } catch (err) {
        console.error("Popup open error:", err);
      }
    }
  });